import MenuItem from "@mui/material/MenuItem";
import MDBox from "components/MDBox";
import { TextField } from "@mui/material";
import colors from "assets/theme-dark/base/colors";
import { styled } from "@mui/system";
import UsersTable from "./UsersTable";
import DeleteCubeDialog from "./DeleteCubeDialog";
import { ClientsResponse, User } from "graphql/types/graphql";

interface Cube {
  cubeId: string;
  name: string;
}

interface UsersCardProps {
  companies: ClientsResponse[];
  roles: string[];
  users: User[];
  role: string | null;
  cruxyId: string | null;
  cubes: Cube[] | undefined;
  selectedCubeId: string | null;
  openDeleteDialog: boolean;
  deleteLoading: boolean;
  setCruxyId: (cruxyId: string | null) => void;
  setRole: (role: string | null) => void;
  setOpenDeleteDialog: (open: boolean) => void;
  handleDeleteCube: () => Promise<void>;
}

const UsersStyledCard = styled(MDBox)`
  width: 50%;
  background: ${colors.background.default};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 1rem;
  border: 1px solid ${colors.grey[300]};
`;

function UsersCard({
  companies,
  roles,
  users,
  role,
  cruxyId,
  cubes,
  selectedCubeId,
  openDeleteDialog,
  deleteLoading,
  setCruxyId,
  setRole,
  setOpenDeleteDialog,
  handleDeleteCube,
}: UsersCardProps): JSX.Element {
  return (
    <UsersStyledCard>
      <MDBox
        sx={{
          display: "flex",
          width: "100%",
          height: "6rem",
          gap: 4,
          alignItems: "center",
        }}
      >
        <TextField
          size="small"
          select
          label="Company"
          sx={{
            width: "20rem",
            "& .MuiSelect-select": {
              color: colors.primary.main,
            },
          }}
        >
          {companies.map((filter: ClientsResponse) => (
            <MenuItem key={filter.cruxyId} onClick={() => setCruxyId(filter.cruxyId)} value={filter.name}>
              {filter.name}
            </MenuItem>
          ))}
          <MenuItem key={"all"} onClick={() => setCruxyId(null)} value={"All"}>
            {"All"}
          </MenuItem>
        </TextField>
        <TextField
          size="small"
          sx={{
            width: "15%",
            minWidth: "140px",
            "& .MuiSelect-select": {
              color: colors.primary.main,
            },
          }}
          value={role}
          select
          label="Role"
        >
          {roles.map((filter: string) => (
            <MenuItem key={filter} onClick={() => setRole(filter)} value={filter}>
              {filter}
            </MenuItem>
          ))}
          <MenuItem key={"all"} onClick={() => setRole(null)} value={"All"}>
            {"All"}
          </MenuItem>
        </TextField>
      </MDBox>
      <UsersTable users={users} />
      <DeleteCubeDialog
        open={openDeleteDialog}
        cubeName={cubes?.find((cube) => cube.cubeId === selectedCubeId)?.name || null}
        onClose={() => setOpenDeleteDialog(false)}
        onDelete={async () => await handleDeleteCube()}
        deleteLoading={deleteLoading}
      />
    </UsersStyledCard>
  );
}

export default UsersCard;
